import { Phone } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function CallSellerButton({ phone }) {
  const [revealed, setRevealed] = useState(false);
  const navigate = useNavigate();

  const masked = phone.replace(/(\d{2})\d{4}(\d{3})/, "$1••••$2");

  return revealed ? (
    <a
      href={`tel:${phone}`}
      className="flex-1 bg-green-600 text-white py-4 rounded-lg font-semibold transition flex items-center justify-center gap-2 hover:bg-green-700"
    >
      <Phone className="w-5 h-5" />
      Call {phone}
    </a>
  ) : (
    <button
      onClick={() => {
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        if (!token || token === "null" || token === "undefined") {
          navigate("/login");
          return;
        }
        setRevealed(true);
      }}
      className="flex-1 bg-white text-gray-900 border border-gray-200 py-4 rounded-lg font-semibold hover:border-gray-900 transition flex items-center justify-center gap-2"
    >
      <Phone className="w-5 h-5" />
      Show number
    </button>
  );
}
